/* eslint-disable simple-import-sort/imports */
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { IResourceGovernanceServerSettings } from '../types/ResourceGovernance';
export namespace GovLimitsCardTestIds {
    export const ConcurrentJobsLimitsHeader = 'concurrentJobsLimitsHeader';
    export const ExtractsLimitsHeader = 'extractsLimitsHeader';
    export const ExtractsLimitsValue = 'extractsLimitsValue';
    export const SubscriptionsLimitsHeader = 'subscriptionsLimitsHeader';
    export const SubscriptionsLimitsValue = 'subscriptionsLimitsValue';
    export const FlowsLimitsHeader = 'flowsLimitsHeader';
    export const FlowsLimitsValue = 'flowsLimitsValue';
    export const DailyJobsLimitsHeader = 'dailyJobsLimitsHeader';
    export const RuntimeLimitsHeader = 'runtimeLimitsHeader';
    export const RuntimeLimitsValue = 'runtimeLimitsValue';
    export const ResetTimeHeader = 'resetTimeHeader';
    export const NextResetValue = 'nextResetValue';
}

const headerStyle: React.CSSProperties = {
    paddingLeft: 5,
    paddingRight: 5,
    fontWeight: 'normal'
};

const valueStyle: React.CSSProperties = {
    paddingLeft: 5,
    paddingRight: 5,
    fontWeight: 'bold'
};

const tableStyle: React.CSSProperties = {
    display: 'inline-table',
    tableLayout: 'fixed',
    marginLeft: 15,
    border: 'solid',
    borderColor: CommonStyles.Colors.Grey230
};

export function SchedulesGovernanceLimitsCard(props: IResourceGovernanceServerSettings) {
    const NO_LIMIT = Messages.resourceGovernanceNoLimitValue();
    const {extractsConcurrencyLimit, subscriptionsConcurrencyLimit, flowsConcurrencyLimit, runtimeLimit, nextResetAt} = props;
    return (
        <div className="tb-indent" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 15}}>
            <span className="tb-settings-group-name" data-tb-test-id={GovLimitsCardTestIds.ConcurrentJobsLimitsHeader} style={{ fontWeight: 'normal', paddingBottom: 0 }}>
                {Messages.resourceGovernanceConcurrentJobsLimitsHeader()}
            </span>
            <table style={ tableStyle }>
                <thead>
                    <tr>
                        <td data-tb-test-id={GovLimitsCardTestIds.ExtractsLimitsHeader} style={ headerStyle }>
                            {Messages.resourceGovernanceExtractsHeader()}
                        </td>
                        <td data-tb-test-id={GovLimitsCardTestIds.SubscriptionsLimitsHeader} style={ headerStyle }>
                            {Messages.resourceGovernanceSubscriptionsHeader()}
                        </td>
                        <td data-tb-test-id={GovLimitsCardTestIds.FlowsLimitsHeader} style={ headerStyle }>
                            {Messages.resourceGovernanceFlowsHeader()}
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td data-tb-test-id={GovLimitsCardTestIds.ExtractsLimitsValue} style={ valueStyle }>
                            {extractsConcurrencyLimit !== undefined ? extractsConcurrencyLimit : NO_LIMIT}
                        </td>
                        <td data-tb-test-id={GovLimitsCardTestIds.SubscriptionsLimitsValue} style={ valueStyle }>
                            {subscriptionsConcurrencyLimit !== undefined ? subscriptionsConcurrencyLimit : NO_LIMIT}
                        </td>
                        <td data-tb-test-id={GovLimitsCardTestIds.FlowsLimitsValue} style={ valueStyle }>
                            {flowsConcurrencyLimit !== undefined ? flowsConcurrencyLimit : NO_LIMIT}
                        </td>
                    </tr>
                </tbody>
            </table>
            <span className="tb-settings-group-name" data-tb-test-id={GovLimitsCardTestIds.DailyJobsLimitsHeader} style={{ fontWeight: 'normal', paddingBottom: 0, paddingLeft: 15 }}>
                {Messages.resourceGovernanceDailyJobsLimitsHeader()}
            </span>
            <table style={ tableStyle }>
                <thead>
                    <tr>
                        <td data-tb-test-id={GovLimitsCardTestIds.RuntimeLimitsHeader} style={ headerStyle }>
                            {Messages.resourceGovernanceRuntimeHeader()}
                        </td>
                        <td data-tb-test-id={GovLimitsCardTestIds.ResetTimeHeader} style={ headerStyle }>
                            {Messages.resourceGovernanceResetHeader()}
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td data-tb-test-id={GovLimitsCardTestIds.RuntimeLimitsValue} style={ valueStyle }>
                            {runtimeLimit !== undefined ? runtimeLimit : NO_LIMIT}
                        </td>
                        <td data-tb-test-id={GovLimitsCardTestIds.NextResetValue} style={ valueStyle }>
                            { Messages.resourceGovernanceMidnightUTC() }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}